/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Rights_Cap_Browser_Use_DescInputs */



/**
* | output |
* | --- |
* | "Allows the assistant to open a real browser and interact with web pages — clicking, typing and scrolling on live sites. Each browsing session must be approve..." |
*
* @param {Rights_Cap_Browser_Use_DescInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const rights_cap_browser_use_desc = /** @type {((inputs?: Rights_Cap_Browser_Use_DescInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Rights_Cap_Browser_Use_DescInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Erlaubt dem Assistenten, einen echten Browser zu öffnen und mit Webseiten zu interagieren — Klicken, Tippen und Scrollen auf live erreichbaren Seiten. Jede Browser-Sitzung muss vor dem Start von der Nutzerin oder dem Nutzer freigegeben werden.")
	return /** @type {LocalizedString} */ ("Allows the assistant to open a real browser and interact with web pages — clicking, typing and scrolling on live sites. Each browsing session must be approved by the user before it starts.")
});